module.exports = __webpack_public_path__ + "static/media/thumb_KKAL_503x503.ebd3687e.jpg";